import React from 'react';

const CheckboxAndRadio = ({ name, id, value, label, checked, onChange, disabled, type }) => {

  return (
    <button
      type="button"
      className={`Checkbox ${checked && 'Checkbox__checked'} ${disabled && 'disabled'}`}
      onClick={onChange}
    >
      <label htmlFor={id} className={`icon-before icon-checkbox ${checked && 'icon-variant-3'}`}>
        <input
          type={type || 'checkbox'}
          className="Checkbox__input"
          name={name}
          id={id}
          value={value}
          checked={checked}
          onChange={onChange}
          aria-label={label}
          disabled={disabled}
        />
        {label}
      </label>
    </button>
  );
};

export default CheckboxAndRadio;
